<template>
  <div id="team" class="team-wrap ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <span>Our Doctors</span>
            <h2>We provide Exceptional Medical Care For Our Patients</h2>
          </div>
        </div>
      </div>

      <div class="team-slider-one style1">
        <Carousel
          :autoplay="5000"
          :wrap-around="true"
          :breakpoints="breakpoints"
          pause-autoplay-on-hover
          class="team-slider-one style1"
        >
          <Slide v-for="team in teams" :key="team.id">
            <div class="team-card style8">
              <div class="team-img">
                <img :src="team.image" alt="Image" />
                <ul class="social-profile list-style style1">
                  <li>
                    <a target="_blank" href="https://facebook.com">
                      <i class="ri-facebook-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://twitter.com">
                      <i class="ri-twitter-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://instagram.com">
                      <i class="ri-instagram-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://linkedin.com">
                      <i class="ri-linkedin-line"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="team-info">
                <h3>{{ team.name }}</h3>
                <span>{{ team.designation }}</span>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Pagination />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "OurDoctors",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    teams: [
      {
        id: 1,
        image: require("../../assets/images/team/member-16.jpg"),
        name: "Dr. Ken Moris",
        designation: "Urology Efficient",
      },
      {
        id: 2,
        image: require("../../assets/images/team/member-17.jpg"),
        name: "Dr. Michel Jhonson",
        designation: "Cardiology Efficient",
      },
      {
        id: 3,
        image: require("../../assets/images/team/member-18.jpg"),
        name: "Dr. Luiz Frank",
        designation: "Neurosurgery Efficient",
      },
      {
        id: 4,
        image: require("../../assets/images/team/member-19.jpg"),
        name: "Dr. Luiz Frank",
        designation: "Neurosurgery Efficient",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>